import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Grid, LinearProgress, Alert } from '@mui/material';
import { fundService, Fund } from '../services/fundService';

const FundAnalyticsPage: React.FC = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [funds, setFunds] = useState<Fund[]>([]);

	useEffect(() => {
		const load = async () => {
			try {
				setLoading(true);
				setError(null);
				const list = await fundService.listFunds(12);
				setFunds(list);
			} catch (e: any) {
				setError(e?.message || 'Failed to load fund analytics');
			} finally {
				setLoading(false);
			}
		};
		load();
	}, []);

	return (
		<Box>
			<Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>Fund Analytics</Typography>
			{loading && <LinearProgress sx={{ mb: 2 }} />}
			{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

			<Grid container spacing={2}>
				{funds.map((f) => (
					<Grid item xs={12} md={6} lg={4} key={f.id}>
						<Paper sx={{ p: 2 }}>
							<Typography variant="h6" sx={{ mb: 1 }}>{f.name}</Typography>
							<Typography variant="body2" color="text.secondary">AUM: {typeof f.aum === 'number' ? f.aum.toLocaleString() : f.aum}</Typography>
							<Typography variant="body2" color="text.secondary">Risk: {f.risk_level}</Typography>
						</Paper>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default FundAnalyticsPage;


